import { create } from 'zustand';
import type { Exam, Question, ExamAttempt } from '../types';

interface ExamState {
  currentExam: Exam | null;
  currentQuestions: Question[];
  currentAttempt: ExamAttempt | null;
  answers: Record<number, string>;
  timeRemaining: number;
  isTimerRunning: boolean;
  flaggedQuestions: number[];
  
  setCurrentExam: (exam: Exam | null) => void;
  setCurrentQuestions: (questions: Question[]) => void;
  setCurrentAttempt: (attempt: ExamAttempt | null) => void;
  setAnswer: (questionId: number, option: string) => void;
  setTimeRemaining: (time: number) => void;
  setTimerRunning: (running: boolean) => void;
  toggleFlagQuestion: (questionId: number) => void;
  clearExam: () => void;
}

export const useExamStore = create<ExamState>((set) => ({
  currentExam: null,
  currentQuestions: [],
  currentAttempt: null,
  answers: {},
  timeRemaining: 0,
  isTimerRunning: false,
  flaggedQuestions: [],
  
  setCurrentExam: (exam) => set({ currentExam: exam }),
  
  setCurrentQuestions: (questions) => set({ currentQuestions: questions }),
  
  setCurrentAttempt: (attempt) => set({ currentAttempt: attempt }),
  
  setAnswer: (questionId, option) =>
    set((state) => ({
      answers: { ...state.answers, [questionId]: option },
    })),
  
  setTimeRemaining: (time) => set({ timeRemaining: time }),
  
  setTimerRunning: (running) => set({ isTimerRunning: running }),
  
  toggleFlagQuestion: (questionId) =>
    set((state) => {
      const flagged = state.flaggedQuestions.includes(questionId)
        ? state.flaggedQuestions.filter((id) => id !== questionId)
        : [...state.flaggedQuestions, questionId];
      return { flaggedQuestions: flagged };
    }),
  
  clearExam: () =>
    set({
      currentExam: null,
      currentQuestions: [],
      currentAttempt: null,
      answers: {},
      timeRemaining: 0,
      isTimerRunning: false,
      flaggedQuestions: [],
    }),
}));
